import "./Icons.scss";
export const IconMessage = ({ classSvg, onClick = null, styleSvg = null }) => {
  return (
    <svg
      className={`icon-message ${classSvg}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styleSvg || {}}
      onClick={onClick}
    >
      <path
        d="M17.5 9.58333C17.5029 10.6832 17.2459 11.7682 16.75 12.75C16.162 13.9264 15.2581 14.916 14.1395 15.6077C13.021 16.2995 11.7319 16.6662 10.4167 16.6667C9.31678 16.6695 8.23176 16.4126 7.25 15.9167L2.5 17.5L4.08333 12.75C3.58744 11.7682 3.33047 10.6832 3.33333 9.58333C3.33384 8.26812 3.70051 6.97904 4.39227 5.86045C5.08402 4.74187 6.07355 3.83797 7.25 3.24999C8.23176 2.7541 9.31678 2.49713 10.4167 2.49999H10.8333C12.5703 2.59582 14.2109 3.32896 15.441 4.55904C16.671 5.78912 17.4042 7.4297 17.5 9.16666V9.58333Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const IconPayments = ({ classSvg, onClick = null, styleSvg = null }) => {
  return (
    <svg
      className={`icon-payments ${classSvg}`}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styleSvg || {}}
      onClick={onClick}
    >
      <path d="M19 14V6C19 4.9 18.1 4 17 4H3C1.9 4 1 4.9 1 6V14C1 15.1 1.9 16 3 16H17C18.1 16 19 15.1 19 14ZM10 13C8.34 13 7 11.66 7 10C7 8.34 8.34 7 10 7C11.66 7 13 8.34 13 10C13 11.66 11.66 13 10 13ZM23 7V18C23 19.1 22.1 20 21 20H4V18H21V7H23Z" />
    </svg>
  );
};
export const IconSearch = ({ classSvg, onClick = null, styleSvg = null }) => {
  return (
    <svg
      className={`icon-search ${classSvg}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styleSvg || {}}
      onClick={onClick}
    >
      <path
        d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconClose = ({ classSvg, onClick = null, styleSvg = null }) => {
  return (
    <svg
      className={`icon-search ${classSvg}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styleSvg || {}}
      onClick={onClick}
    >
      <path
        d="M15.8334 4.16667L4.16675 15.8333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8334 15.8333L4.16675 4.16667"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconSend = ({ classSvg, onClick = null, styleSvg = null }) => {
  return (
    <svg
      className={`icon-send ${classSvg}`}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styleSvg || {}}
      onClick={onClick}
    >
      <path d="M22.3345 13.8833C22.3357 14.3446 22.2025 14.7964 21.9512 15.1833C21.7074 15.5741 21.3537 15.8842 20.9345 16.075L9.14286 21.7916C8.81448 21.9566 8.45199 22.0422 8.08452 22.0416C7.93037 22.0419 7.77666 22.0251 7.62619 21.9916C7.1114 21.895 6.64281 21.6314 6.29285 21.2416C5.94037 20.8523 5.72381 20.3591 5.67572 19.8361C5.62763 19.3131 5.75062 18.7887 6.02619 18.3416L8.89286 14.3583C8.95908 14.2 8.99307 14.03 8.99285 13.8583C8.99317 13.6732 8.95037 13.4906 8.86786 13.325L6.21785 9.57497C5.94404 9.11957 5.82969 8.58592 5.89285 8.0583C5.94981 7.55167 6.16607 7.07618 6.5105 6.7003C6.85494 6.32442 7.30977 6.06753 7.80952 5.96664C8.31207 5.8681 8.83277 5.92627 9.30118 6.13331L20.9679 11.6916C21.3778 11.8926 21.7231 12.2046 21.9647 12.592C22.2063 12.9794 22.3344 13.4267 22.3345 13.8833Z" />
    </svg>
  );
};

export const IconSendPhoto = ({ classSvg, onClick = null, styleSvg = null }) => {
  return (
    <svg
      className={`icon-send-photo ${classSvg}`}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styleSvg || {}}
      onClick={onClick}
    >
      <path d="M16.25 2.75H7.75C6.22582 2.75264 4.76477 3.35928 3.68701 4.43704C2.60925 5.5148 2.00264 6.97582 2 8.5V15.5C2.00264 17.0242 2.60925 18.4852 3.68701 19.5629C4.76477 20.6407 6.22582 21.2474 7.75 21.25H16.25C17.7742 21.2474 19.2352 20.6407 20.313 19.5629C21.3907 18.4852 21.9974 17.0242 22 15.5V8.5C21.9974 6.97582 21.3907 5.5148 20.313 4.43704C19.2352 3.35928 17.7742 2.75264 16.25 2.75ZM8 6.09998C8.63917 6.09998 9.25214 6.35388 9.7041 6.80585C10.1561 7.25781 10.41 7.87081 10.41 8.50998C10.41 9.14915 10.1561 9.76215 9.7041 10.2141C9.25214 10.6661 8.63917 10.92 8 10.92C7.68351 10.9193 7.37027 10.8563 7.07812 10.7346C6.78598 10.6129 6.52069 10.4348 6.29736 10.2106C5.84634 9.75767 5.59364 9.14415 5.59497 8.50497C5.5963 7.8658 5.85154 7.25336 6.30444 6.80234C6.75734 6.35131 7.37084 6.09865 8.01001 6.09998H8ZM20.5 12.78L18.3201 11.09C17.6921 10.6523 16.9301 10.4495 16.1677 10.5172C15.4053 10.5848 14.6911 10.9186 14.15 11.46L11.8201 13.79C11.3322 14.262 10.6986 14.5546 10.0229 14.62C9.34726 14.6854 8.6693 14.5197 8.09998 14.15C7.82251 13.9667 7.49143 13.8821 7.16003 13.91C6.82724 13.945 6.51656 14.0933 6.28003 14.33L3.84998 17.17C3.58748 16.5689 3.46771 15.9151 3.5 15.26L5.18005 13.31C5.66449 12.8204 6.30263 12.5125 6.9873 12.4378C7.67198 12.3631 8.3615 12.5263 8.94006 12.9C9.21668 13.0873 9.55012 13.1719 9.88257 13.139C10.215 13.1061 10.5254 12.9579 10.76 12.72L13.09 10.4C13.8873 9.60532 14.9399 9.11824 16.0618 9.0249C17.1836 8.93157 18.3023 9.238 19.22 9.88998L20.5 10.89V12.78Z" />
      <path d="M8.90983 8.5101C8.90983 8.69008 8.85638 8.86604 8.75638 9.01569C8.65639 9.16533 8.51434 9.28195 8.34806 9.35083C8.18178 9.41971 7.99882 9.43773 7.8223 9.40262C7.64578 9.36751 7.48363 9.28083 7.35636 9.15356C7.22909 9.0263 7.14245 8.86418 7.10734 8.68765C7.07222 8.51113 7.09022 8.32815 7.15909 8.16187C7.22797 7.99558 7.34453 7.85347 7.49418 7.75348C7.64383 7.65349 7.81981 7.6001 7.99979 7.6001C8.1193 7.6001 8.23765 7.62364 8.34806 7.66937C8.45847 7.7151 8.55872 7.78214 8.64323 7.86664C8.72773 7.95114 8.79476 8.05146 8.84049 8.16187C8.88622 8.27227 8.90983 8.3906 8.90983 8.5101Z" />
    </svg>
  );
};

export const IconSendDocument = ({ classSvg, onClick = null, styleSvg = null }) => {
  return (
    <svg
      className={`icon-send-document ${classSvg}`}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styleSvg || {}}
      onClick={onClick}
    >
      <path d="M11.96 1.75004C9.93447 1.75795 7.95668 2.36579 6.27635 3.49687C4.59601 4.62795 3.28848 6.23155 2.51881 8.10518C1.74914 9.9788 1.55185 12.0385 1.95186 14.0241C2.35186 16.0098 3.33124 17.8324 4.76631 19.2619C6.20138 20.6914 8.02779 21.6637 10.015 22.0559C12.0022 22.4482 14.0611 22.2429 15.9317 21.4659C17.8023 20.689 19.4008 19.3752 20.5253 17.6904C21.6498 16.0057 22.25 14.0256 22.25 12C22.2487 10.651 21.9813 9.31544 21.4633 8.06984C20.9452 6.82423 20.1866 5.69301 19.2308 4.74095C18.275 3.78889 17.1409 3.03469 15.8933 2.52147C14.6456 2.00825 13.309 1.7461 11.96 1.75004ZM17.25 13H12.97V17.27C12.97 17.5352 12.8646 17.7896 12.6771 17.9772C12.4896 18.1647 12.2352 18.27 11.97 18.27C11.7048 18.27 11.4504 18.1647 11.2629 17.9772C11.0754 17.7896 10.97 17.5352 10.97 17.27V13H6.69001C6.4248 13 6.17043 12.8947 5.98289 12.7071C5.79536 12.5196 5.69001 12.2653 5.69001 12C5.69001 11.7348 5.79536 11.4805 5.98289 11.2929C6.17043 11.1054 6.4248 11 6.69001 11H10.97V6.68004C10.97 6.41482 11.0754 6.16048 11.2629 5.97294C11.4504 5.78541 11.7048 5.68004 11.97 5.68004C12.2352 5.68004 12.4896 5.78541 12.6771 5.97294C12.8646 6.16048 12.97 6.41482 12.97 6.68004V10.96H17.25C17.5152 10.96 17.7696 11.0654 17.9571 11.2529C18.1446 11.4405 18.25 11.6948 18.25 11.96C18.25 12.2253 18.1446 12.4796 17.9571 12.6672C17.7696 12.8547 17.5152 12.96 17.25 12.96V13Z" />
    </svg>
  );
};

export const IconClearDocument = ({ classSvg, onClick = null, styleSvg = null }) => {
  return (
    <svg
      className={`icon-clear-document ${classSvg}`}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styleSvg || {}}
      onClick={onClick}
    >
      <path
        d="M14.2223 2.71704C13.0855 1.5802 11.6374 0.805631 10.0607 0.491171C8.48409 0.176705 6.84962 0.336444 5.36368 0.950188C3.87775 1.56393 2.60694 2.60419 1.71179 3.93957C0.816586 5.275 0.337161 6.8457 0.333966 8.4534C0.330771 10.0611 0.803948 11.6337 1.69387 12.9726C2.58372 14.3116 3.85037 15.3569 5.33388 15.9765C6.81732 16.5962 8.45117 16.7624 10.0291 16.4541C11.6069 16.1459 13.0581 15.3772 14.1994 14.2448C14.9588 13.4899 15.5618 12.5927 15.974 11.6045C16.3862 10.6162 16.5995 9.55643 16.6016 8.48567C16.6037 7.41492 16.3947 6.3543 15.9864 5.36446C15.5781 4.37455 14.9786 3.47491 14.2223 2.71704ZM10.8408 11.9866L8.44822 9.57511L6.04234 11.9621C5.89292 12.1104 5.69066 12.1932 5.48014 12.1925C5.26968 12.1916 5.06813 12.1072 4.91988 11.9577C4.77163 11.8083 4.68874 11.6061 4.68957 11.3956C4.69045 11.1851 4.77487 10.9835 4.92429 10.8353L7.33017 8.44824L4.93755 6.03673C4.7893 5.8873 4.70643 5.68511 4.70729 5.47457C4.7081 5.26409 4.79249 5.06257 4.94197 4.91426C5.09139 4.76601 5.29357 4.68321 5.5041 4.684C5.71459 4.68485 5.91617 4.76925 6.06443 4.91868L8.45705 7.33019L10.8911 4.91522C11.0405 4.76696 11.2427 4.68416 11.4532 4.68497C11.6637 4.68578 11.8653 4.77021 12.0135 4.91964C12.1618 5.06906 12.2446 5.2713 12.2438 5.48178C12.2429 5.69227 12.1586 5.89384 12.0091 6.0421L9.59764 8.4347L11.9903 10.8462C12.1385 10.9956 12.2213 11.1979 12.2205 11.4084C12.2196 11.6189 12.1353 11.8204 11.9858 11.9687C11.8364 12.117 11.6342 12.1998 11.4236 12.199C11.2132 12.1982 11.0116 12.1137 10.8634 11.9643L10.8408 11.9866Z"
        fill="black"
        fillOpacity="0.2"
      />
    </svg>
  );
};

export const IconClinch = ({ classSvg, onClick = null, styleSvg = null }) => {
  return (
    <svg
      className={`icon-clinch ${classSvg}`}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styleSvg || {}}
      onClick={onClick}
    >
      <path
        d="M17.548 14.0511L14.0208 17.7979C13.0854 18.7916 11.7935 19.373 10.4293 19.4142C9.06521 19.4554 7.74059 18.953 6.74689 18.0175C5.75318 17.082 5.17179 15.7901 5.13061 14.426C5.08943 13.0618 5.59184 11.7372 6.52731 10.7435L11.2302 5.74784C11.8539 5.08537 12.7151 4.69777 13.6246 4.67032C14.534 4.64287 15.4171 4.97781 16.0795 5.60145C16.742 6.2251 17.1296 7.08637 17.1571 7.99579C17.1845 8.90521 16.8496 9.78829 16.2259 10.4508L11.523 15.4464C11.2112 15.7777 10.7805 15.9715 10.3258 15.9852C9.87112 15.9989 9.42958 15.8315 9.09835 15.5196C8.76711 15.2078 8.57331 14.7772 8.55959 14.3225C8.54586 13.8678 8.71333 13.4262 9.02515 13.095L13.7281 8.0993"
        stroke="#788497"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconPlay = ({ classSvg, onClick = null, styleSvg = null }) => {
  return (
    <svg
      className={`icon-play ${classSvg}`}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styleSvg || {}}
      onClick={onClick}
    >
      <path d="M2.29942 5.02228L6.43314 2.17791C7.09661 1.72138 8 2.19636 8 3.00172L8 13.0023C8 13.8156 7.08064 14.2888 6.41877 13.816L2.25631 10.8429C1.46791 10.2798 1 9.37055 1 8.40169V7.49372C1 6.50626 1.48593 5.58203 2.29942 5.02228ZM11.8891 11.8891C12.9205 10.8576 13.5 9.45869 13.5 8C13.5 6.54131 12.9205 5.14236 11.8891 4.11091L12.9497 3.05025C14.2625 4.36301 15 6.14349 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497L11.8891 11.8891ZM10.5 8C10.5 8.66304 10.2366 9.29893 9.76777 9.76777L10.8284 10.8284C11.5786 10.0783 12 9.06087 12 8C12 6.93913 11.5786 5.92172 10.8284 5.17157L9.76777 6.23223C10.2366 6.70107 10.5 7.33696 10.5 8Z" />
    </svg>
  );
};
